import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Make sure the basename is set correctly for GitHub Pages
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="875451325531-a6lhu87s5p1j9vq1o4lkc0hn5oqbfm7q.apps.googleusercontent.com">
      <BrowserRouter basename="/ScalerConnect">
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
